import React, {  Component } from 'react';

export default class FedExShipmentConfirmationOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog(false, "FedExShipmentConfirmationOverlayDialog");
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="fedExShipmentConfirmationOverlayDialog">
                <div className="blackoutLayer"></div>
                    <div className="overlayDialogWindow">
                        <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                        <h2 className="title">FedEx Shipment Confirmation</h2>
                        <p>Do you want to ship this order FedEx?</p>
						<div className="noButtonContainer">
			              	<a onClick={(e) => this.props.continueDeliveryWith(this.props.currentDeliveryMethod, e)} href="" className="noButton blueButton">No</a>
			            </div>
			            <div className="yesButtonContainer">
							<a onClick={(e) => this.props.continueDeliveryWith("FedEx Ground", e)} href=""className="yesButton blueButton">Yes</a>
			            </div>
                    </div>
                </div>
            );
        }
    }



// WEBPACK FOOTER //
// ./src/App/components/dialogs/fedExShipmentConfirmationOverlayDialog.js